import { useState, type FC } from 'react'

import { Checkbox, CheckboxGroup } from '@wartek-id/checkbox-v1'
import { Dialog, DialogContent, DialogOverlay } from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'
import { Button } from '@wartek-id/button-v1'

type DialogConfirmationDiskusiTindakLanjutProps = {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  isLoading: boolean
}

const DialogConfirmationDiskusiTindakLanjut: FC<
  DialogConfirmationDiskusiTindakLanjutProps
> = ({ isOpen, onClose, onConfirm, isLoading }) => {
  const [selected, setSelected] = useState([])
  const isConfirmed = selected.filter((item) => item !== '').length === 3

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      autoFocus={false}
      returnFocus={false}
      size="sm"
    >
      <DialogOverlay />
      <DialogContent>
        <div className="p-6 space-y-6">
          <div className="space-y-2">
            <Text variant="heading-md">Saya menyatakan sudah:</Text>

            <div className="py-3">
              <CheckboxGroup
                name="some-name"
                onChange={setSelected}
                value={selected}
                className="flex flex-col gap-2"
              >
                <Checkbox value="proses_diskusi" labelPosition="center">
                  <Text variant="body">Menyelesaikan proses diskusi</Text>
                </Checkbox>
                <Checkbox value="penilaian" labelPosition="center">
                  <Text variant="body">
                    Mengetahui Tim Kinerja akan memberikan hasil pemantauan
                    berdasarkan: proses diskusi, isi catatan, dan survei Kepala
                    Satuan Pendidikan Nonformal
                  </Text>
                </Checkbox>
                <Checkbox value="eksekusi" labelPosition="center">
                  <Text variant="body">
                    Mengetahui bahwa Upaya Tindak Lanjut akan dilakukan setelah
                    ini
                  </Text>
                </Checkbox>
              </CheckboxGroup>
            </div>
          </div>

          <div className="flex justify-start gap-3">
            <Button
              size="lg"
              variant="solid"
              color="white"
              onClick={onClose}
              disabled={isLoading}
            >
              Kembali
            </Button>
            <Button
              size="lg"
              variant="solid"
              color="blue"
              onClick={onConfirm}
              disabled={!isConfirmed || isLoading}
            >
              Konfirmasi
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default DialogConfirmationDiskusiTindakLanjut
